import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { HelpService } from '../../services/help/help.service';
import { TabService } from '../../services/tab/tab.service';
import { DataTableService } from '../../services/dataTable/dataTable.service';

@Component({
	selector: 'pcm-page-blockchain-invoices',
	templateUrl: './page-blockchain-invoices.component.html',
	styleUrls: ['./page-blockchain-invoices.component.scss']
})
export class PageBlockchainInvoicesComponent implements OnInit, OnDestroy {
	title = 'Blockchain Invoices';
	dataObj = this.invoiceService.bcDataObj;
	objRoot = 'blockchain-invoice';
	selectionType = 'checkbox';
	actions = [];
	showExportModal = false;
	columnsConfig = [];

	jrSteps = [];
	jrStepIDs = [];

	initTab = '';

	defaultSort = [
		{
			prop: this.configService.invoiceChaincodeProp + '.' + this.configService.invoiceDateProp,
			dir: 'desc'
		}
	];

	userSettingsListener;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private commsService: CommsService,
		public configService: ConfigService,
		private dataService: DataService,
		private helpService: HelpService,
		public invoiceService: InvoiceService,
		private tabService: TabService,
		private dataTableService: DataTableService
	) {
	}

	ngOnInit() {
		this.columnsConfig = this.configService.getTableFields(this.dataObj, false);
		this.actions = [this.configService.getExportAction()];
		this.invoiceService.bcDataConfig = this.configService.getDataObj(this.dataObj);

		this.helpService.supplier_invoices.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});

		this.route.params.subscribe(params => {
			this.initTab = params['initTab'];
			this.tabService.loadTab(this.invoiceService.tabsData.bcListTabs, this.invoiceService, this.initTab);
		});

		this.userSettingsListener = this.dataService.userSettingsListener().subscribe((event) => {
			console.log('USER SETTINGS LISTENER');
			this.tabService.loadTab(this.invoiceService.tabsData.bcListTabs, this.invoiceService, this.initTab);
		});
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		if (event.action.prop === 'exporttocsv') {
			this.showExportModal = true;
		}
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.configService.getTableFields(this.dataObj, false), this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}

	tablePage(event) {
		console.log('INVOICE TABLE PAGE: ', event);
		const activeTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.bcListTabs);
		activeTab['page'] = event.offset;
		this.invoiceService.loadInvoicesForTab(activeTab);
	}

	tableSort(event) {
		this.dataTableService.tableSort(
			event,
			this.invoiceService.getActiveTab(this.invoiceService.tabsData.bcListTabs), (tab) => this.invoiceService.loadInvoicesForTab(tab)
		);
	}

	tableSearch(event) {
		console.log('INVOICE TABLE SEARCH: ', event);
		const activeTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.bcListTabs);
		this.invoiceService.loadInvoicesForTab(activeTab);
	}

	tableRefresh(event) {
		console.log('INVOICE TABLE REFRESH: ', event);
		const activeTab = this.invoiceService.getActiveTab(this.invoiceService.tabsData.bcListTabs);
		this.invoiceService.loadInvoicesForTab(activeTab);
	}

	tableClick(event) {
		console.log('BC Invoice TABLE CLICK: ', event);
		const clickedRow = event.row;
		const data = {
			ponumber: clickedRow[this.configService.poNumberProp],
			supplierid: clickedRow[this.configService.supplierIdProp],
			billingstart: clickedRow[this.configService.invoiceStartProp],
			billingend: clickedRow[this.configService.invoiceEndProp],
			invoicetype: clickedRow['invoicetype'],
			contractoruuid: clickedRow['contractoruuid']
		};

		this.openBCInvoice(data);
	}

	openBCInvoice(data) {
		this.router.navigateByUrl(this.objRoot + '/' + data.ponumber + '/' + data.supplierid
		+ '/' + data.billingstart + '/' + data.billingend + '/' + data.invoicetype + '/' + data.contractoruuid );
	}
}
